import React, { Fragment, useContext, useEffect, useState } from "react";
import { APIContext } from "src/components/Contexts/APIContext";
import { SentimentChartViewModel } from "../Transcripts/SentimentChartViewModel";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Legend,
    Tooltip,
    Title
} from 'chart.js';

interface IProps {
    callRefId?: string;
    switchCallId?: string;
    height: string;
    isAgent: boolean;
}

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Legend,
    Tooltip,
    Title
);

export const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            stacked: true,
            grid: {
                color: ({ tick }) => {
                    if (tick !== undefined) {
                        return tick.value === 1 || tick.value === 2 ? "black" : "rgba(0, 0, 0, 0.1)"
                    }
                    else return;
                }
            },
        },
        y: {
            stacked: true,
            title: {
                display: true,
                font: {
                    weight: "bold",
                    size: 16
                },
                text: 'Score'
            },
            grid: {
                color: ({ tick }) => tick.value === 0 ? "black" : "rgba(0, 0, 0, 0.1)"
            },
            min: -10,
            max: 10,
            ticks: {
                callback: (value) => {
                    if (value === -10) return 'Extremely Negative: -10';
                    if (value === -7) return 'Very Strong Negative: -7';
                    if (value === -4) return 'Strong Negative: -4';
                    if (value === -1) return 'Mildly Negative: -1';
                    if (value === 0) return 'Neutral:  0';
                    if (value === 1) return 'Mildly Positive: 1';
                    if (value === 4) return `Strong Positive: 4`;
                    if (value === 7) return 'Very Strong Positive: 7';
                    if (value === 10) return 'Extremely Positive: 10';
                    return '';
                }
            }
        },
    },
    plugins: {
        tooltip: {
            callbacks: {
                label: function (context) {
                    let label = context.dataset.label || '';
                    if (label)
                        label += ': ';
                    if (context.parsed.y !== null)
                        label += context.parsed.y;
                    return label;
                }
            }
        }
    }
}

export default function CustomerExperienceChart(props: IProps) {
    const { get } = useContext(APIContext);
    const [data, setData] = useState<SentimentChartViewModel | null>(null);


    useEffect(() => {
        if (props.switchCallId) {
            getCallChartData(props.switchCallId);
        }
        else if (props.callRefId) {
            getCallChartData(props.callRefId);
        }
    }, [props.switchCallId, props.isAgent])

    const getCallChartData = (id: string) => {
        get('Transcript', `GetCallSummaryChartData?switchCallId=${id}&isAgent=${props.isAgent}`, (data) => setData(data))
    }

    return (
        <Fragment>
            <Typography variant="h6" sx={{ pl: 1 }}><u>{(props.isAgent ? 'Agent' : 'Customer') + ' Experience Journey'}</u></Typography>
            <Box height={props.height} sx={{ pl: 1, pr: 1 }}>
                {
                    data ?
                        <Bar options={options} data={data} />
                        :
                        <Typography>No chart data found this call</Typography>
                }
            </Box>
        </Fragment>
    );
}